{
  "assets": {
    "upload_new": "Sube un nuevo {{ assetType }}"
  },
  "edit_layer": {
    "discard_title": "Cambios no guardados",
    "discard_message": "Al hacer clic en Sí, aceptas descartar todos los cambios no guardados realizados en esta capa. ¿Aún desea continuar?"
  },
  "move": {
    "moveTo": "Mudarse a esta ubicación",
    "setTo": "Establecer una nueva ubicación",
    "tooltip": {
      "Map": "No se puede pasar a un plan",
      "Layer": "No se puede mover a una capa"
    },
    "tooltip_self": "No se puede mover una carpeta a sí misma"
  },
  "fixed_shape": {
    "length": "Longitud",
    "width": "Anchura"
  },
  "mapObjectSidebarOptions": {
    "hide_object": "Ocultar objeto",
    "show_object": "Mostrar objeto",
    "hide_group": "Ocultar grupo",
    "show_group": "Mostrar grupo"
  },
  "object_details": {
    "minimise": "Minimiza los detalles del objeto",
    "edit_attributes": "Gestione los atributos",
    "object_details": "DETALLES DEL OBJETO",
    "object_name": "Nombre del objeto"
  },
  "verticalBarErrors": {
    "layer_hidden_drawing": "No puede editar una capa que está oculta",
    "layer_locked_drawing": "No puede editar una capa que está bloqueada",
    "hide_layer_composition": "No puede ocultar una capa mientras la está editando",
    "group_composition": "No puede ocultar un grupo mientras edita una de sus capas"
  },
  "export_map": {
    "export_map": "Plan de exportación",
    "export_preview": "Vista previa de exportación",
    "lock_map": "Bloquear la ventana gráfica",
    "orientation": {
      "title": "Orientación de la página",
      "portrait": "Retrato",
      "landscape": "Paisaje"
    },
    "page_size": {
      "title": "Tamaño de página"
    },
    "file_format": {
      "title": "Formato de archivo"
    },
    "scale": "Escala",
    "infoTooltip": {
      "title": "Viewport",
      "text": "Haga clic en el mapa para desplazarse y ajustar la ventana gráfica y, a continuación, bloquee la ventana gráfica para guardar los cambios en el editor."
    },
    "positionMapOverlay": {
      "title": "Sitúe el mapa",
      "text": "Desplace, amplíe y gire para elegir el área que desea exportar"
    },
    "read_user_visibility_warning": "Las exportaciones excluyen los cambios de visibilidad de los usuarios sin permiso de acceso total en el mapa."
  },
  "styles": {
    "customiseColour": "Personaliza el color",
    "scaleText": "Icono de escala para que se ajuste al texto",
    "textMargin": "Margen de texto",
    "modelVariableSizeError": "Valor no válido. Asegúrate de que todos los valores estén entre {{ minValue }} y {{ maxValue }}",
    "dimensions": "Dimensiones",
    "customDimensions": "Personalice las dimensiones de los modelos",
    "customColour": "Permita el color personalizado.",
    "customImage": "Permitir la imagen personalizada (la relación de aspecto es opcional).",
    "widthLengthHeight": "Anchura, longitud, altura"
  },
  "permissions": {
    "permission_is": "El permiso es",
    "readonly": "de solo lectura",
    "map": "en un plan",
    "layer": "una capa",
    "selection": "en la selección"
  },
  "layer_overflow": {
    "hidden_text": "Menú de desbordamiento de capas",
    "layer_properties": "Configuración de capas",
    "attribute_table": "Tabla de atributos",
    "delete_layer": "Eliminar capa",
    "layer_view": {
      "display_text": "Vista de capas",
      "view_by_object": "Ver por objeto",
      "view_by_attribute": "Ver por atributo"
    },
    "remove_from_map": "Eliminar del plan",
    "manage_permissions": "Administra los permisos"
  },
  "plan": "Planes",
  "dashboard": "Tablero",
  "units": {
    "feet": "Pies"
  },
  "controls": {
    "set_pitch": "Inclina la vista"
  },
  "toolbarButtonTooltips": {
    "helpButton": "Ayuda",
    "layers": "Volver a las capas"
  }
}